module.exports = __webpack_public_path__ + "static/img/材料研制.0e4ae30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/材料研制.jpg
// module id = LLe1
// module chunks = 1